import { useState } from 'react';
import { signIn } from '../lib/supabase';

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await signIn(email, password);
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      onLogin(data.session);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoWrap}>
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            alt="The LAB"
            style={styles.logo}
            onError={e => { e.target.style.display = 'none'; }}
          />
        </div>

        <div style={styles.eyebrow}>Statistical Sampling Platform</div>
        <h1 style={styles.title}>Sign In</h1>
        <p style={styles.sub}>The LAB Business Solutions · Secure Access</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoFocus
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <div style={styles.errorBox}>{error}</div>}

          <button
            type="submit"
            style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <div style={styles.footer}>
          Access is invitation-only. Contact your administrator.
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0D2461 0%, #091849 60%, #0a1f54 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Montserrat', sans-serif",
    padding: '24px',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '48px 44px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
  },
  logoWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  logo: {
    height: '80px',
    objectFit: 'contain',
  },
  eyebrow: {
    fontFamily: "'Roboto Mono', monospace",
    fontSize: '10px',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#F5A800',
    textAlign: 'center',
    marginBottom: '6px',
  },
  title: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 800,
    fontSize: '28px',
    color: '#0D2461',
    textAlign: 'center',
    margin: '0 0 4px',
  },
  sub: {
    fontFamily: "'Roboto Mono', monospace",
    fontSize: '11px',
    color: '#8a96b0',
    textAlign: 'center',
    marginBottom: '32px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontFamily: "'Roboto Mono', monospace",
    fontSize: '11px',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#5a6a8a',
  },
  input: {
    padding: '12px 14px',
    border: '1.5px solid #c8d0e0',
    borderRadius: '6px',
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '14px',
    color: '#0D2461',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  errorBox: {
    background: '#fff0ee',
    border: '1px solid #e05a3a',
    borderRadius: '6px',
    padding: '10px 14px',
    fontFamily: "'Roboto Mono', monospace",
    fontSize: '12px',
    color: '#c03a1a',
  },
  btn: {
    marginTop: '8px',
    padding: '14px',
    background: '#F5A800',
    color: '#0D2461',
    border: 'none',
    borderRadius: '6px',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 800,
    fontSize: '14px',
    letterSpacing: '0.04em',
    cursor: 'pointer',
    transition: 'background 0.15s',
  },
  footer: {
    marginTop: '24px',
    fontFamily: "'Roboto Mono', monospace",
    fontSize: '11px',
    color: '#a0aac0',
    textAlign: 'center',
    lineHeight: '1.6',
  },
};
